import { useState } from 'react'
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap'
import { useProfile } from '../contexts/ProfileContext'
import reportService from '../services/reportService'

function ReportModal({ show, onHide, item }) {
  const { activeProfile } = useProfile()
  const [reason, setReason] = useState('')
  const [details, setDetails] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!reason) {
      setError('Please select a reason')
      return
    }

    if (!activeProfile) {
      setError('No active profile selected')
      return
    }

    setLoading(true)
    setError(null)

    try {
      await reportService.createReport({
        profile_id: activeProfile.id,
        scorable_id: item.id,
        reason,
        details: details || undefined
      })

      setSuccess(true)

      // Close modal after short delay
      setTimeout(() => {
        handleClose()
      }, 1500)
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit report')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setReason('')
    setDetails('')
    setError(null)
    setSuccess(false)
    setLoading(false)
    onHide()
  }

  if (!item) return null

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Report Content</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {success ? (
          <Alert variant="success">
            Report submitted successfully. This content will be hidden from your account.
          </Alert>
        ) : (
          <Form onSubmit={handleSubmit}>
            <div className="mb-3">
              <strong>Reporting:</strong>{' '}
              <span className="text-muted">{item.pretty_name || item.thing}</span>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <Alert variant="info" className="small">
              Reporting this content will hide it from all profiles under your account.
              A site administrator will review your report.
            </Alert>

            <Form.Group className="mb-3">
              <Form.Label>Reason for reporting *</Form.Label>
              <Form.Select
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                required
              >
                <option value="">Select a reason...</option>
                {reportService.REPORT_REASONS.map(r => (
                  <option key={r.value} value={r.value}>{r.label}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Additional details (optional)</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={details}
                onChange={(e) => setDetails(e.target.value)}
                placeholder="Provide any additional context..."
                maxLength={1000}
              />
              <Form.Text className="text-muted">
                {details.length}/1000 characters
              </Form.Text>
            </Form.Group>
          </Form>
        )}
      </Modal.Body>

      {!success && (
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleSubmit}
            disabled={loading || !reason}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Submitting...
              </>
            ) : (
              'Submit Report'
            )}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default ReportModal
